export default {
  data() {
    return {
      isShowing: false,
    }
  },
  props: {
    disappearedAt: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.isShowing = this.$func.displayer({
      disappearedAt: this.disappearedAt,
    })
  },
  render() {
    if (!this.isShowing) return null

    return this.$slots.default
  },
}
